import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { CclDrawerService, CclBuilderService, CclMessageService, CclNavbarFooterService } from "certain-common-library";

import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-speaker-page",
    templateUrl: "./speaker-page.view.html",
    styleUrls: []
})
export class SpeakerPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    speakerConfigObj: any;

    speakerConfig: any = {};
    basedOnImageName: any = {};

    ddfData: Array<any> = [];
    hover = false;
    templateStyles: any = {
        l_circular: "Layout w/ Circular Image",
        l_noimage: "Layout without Image",
        l_square: "Layout w/ Square Image",
        l_banner: "Layout w/ Banner Image"
    };
    bodyLayout: string;
    fontstyle: any = {};

    constructor(
        public sharedService: SharedService,
        private drawerService: CclDrawerService,
        public builderService: CclBuilderService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private localDataService: LocalDataService
    ) {
        super(sharedService);
        this.localDataService.getJSON("speaker-ddf.json").subscribe((data) => {
            if (data != null) {
                this.ddfData = data;
            }
            if (this.sharedService.speakerCustomFields != null) {
                this.sharedService.speakerCustomFields.forEach((cf) => {
                    this.ddfData.push({
                        label: cf.name,
                        key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                        type: "Speaker custom field"
                    });
                });
            }
            this.bodyLayout = this.getFormattedDDFData("body");
        });
        this.subscription = this.messageService.getMessage().subscribe((message) => this.saveSpeakerConfig(message));
    }

    getFormattedDDFData(expansionStyle) {
        let contentString = this.sharedService.speakerLayoutConfig.catalogConfig[expansionStyle].textConfig.template;
        if (contentString != null) {
            this.ddfData.forEach(function(value, key) {
                if (contentString.indexOf(value.key) > -1) {
                    contentString = contentString.replace(new RegExp(value.key, "g"), value.label);
                }
            });
            return contentString
                .replace(new RegExp('contenteditable="true"', "g"), "")
                .replace(new RegExp("contenteditable='true'", "g"), "");
        } else {
            return "";
        }
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.sharedService.currentLayoutSection = "speaker";
        this.speakerConfigObj = this.sharedService.configs[this.sharedService.configTypes.SPEAKER_CONFIG];
        if (this.speakerConfigObj == null || this.speakerConfigObj.id == null) {
            this.speakerConfig = cloneDeep(this.sharedService.speakerLayoutConfig);
            this.speakerConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.SPEAKER_CONFIG
            };
        } else {
            this.speakerConfig = JSON.parse(this.speakerConfigObj.config);
            this.sharedService.speakerLayoutConfig = cloneDeep(this.speakerConfig);
        }
        
        
        if(!('enableSpeakerPopup' in this.speakerConfig.catalogConfig)) {
            this.speakerConfig.catalogConfig.enableSpeakerPopup = true;
        }
        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.speakerConfig);
        this.sharedService.changedData = this.speakerConfig;

        this.fontstyle = {
            color: this.speakerConfig.labelConfig.fontColor,
            "font-style": this.speakerConfig.labelConfig.fontStyle,
            "text-decoration": this.speakerConfig.labelConfig.fontStyle,
            "font-weight": this.speakerConfig.labelConfig.fontStyle,
            "font-size": this.speakerConfig.labelConfig.fontSize + "px",
            "padding-right": "5px"
        };
        this.setBasedOnImageNameHelper("body");
    }

    private setBasedOnImageNameHelper(property) {
        if (this.speakerConfig.catalogConfig[property].imageConfig.basedOn == "speaker_img") {
            this.basedOnImageName[property] = "Speaker <br/> Profile <br/> Image";
        } else if (this.speakerConfig.catalogConfig[property].imageConfig.basedOn == "dynamic_img") {
            var img = this.speakerConfig.catalogConfig[property].imageConfig.dynamicImage;
            var filename = img.replace(/^.*[\\\/]/, "");
            var encodeFileName = encodeURIComponent(filename);
            var imgURL = img.replace(filename, encodeFileName);
            var imgHeight = this.speakerConfig.catalogConfig[property].imageConfig.height;
            var imgWidth = this.speakerConfig.catalogConfig[property].imageConfig.width;
            if (this.speakerConfig.layout == "l_circular") {
                this.basedOnImageName[property] =
                    "<img alt='Dynamic image uploaded' class='img-border-radius' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            } else if (this.speakerConfig.layout == "l_square") {
                this.basedOnImageName[property] =
                    "<img alt='Dynamic image uploaded' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            }
        } else {
            if (this.sharedService.speakerFileCustomFields != null) {
                this.sharedService.speakerFileCustomFields.forEach((cf) => {
                    if ("custom_" + cf.code == this.speakerConfig.catalogConfig[property].imageConfig.basedOn) {
                        this.basedOnImageName[property] = cf.name;
                    }
                });
            }
        }
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label =
                "NEXT STEP: Define Log-In popup content and SSO";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-speaker";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-speaker";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveSpeakerConfig(message) {
        if (message.text == "save-speaker" || message.text == "save-next-speaker") {
            this.speakerConfigObj.config = JSON.stringify(this.speakerConfig);
            this.catalogService.saveSetupConfig(this.speakerConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.speakerConfig);
                this.sharedService.changedData = this.speakerConfig;

                this.speakerConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[this.sharedService.configTypes.SPEAKER_CONFIG] = this.speakerConfigObj;
                this._flashMessagesService.show("Speaker layout saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-speaker") {
                    this.sharedService.currentLayoutSection = "login";
                    this.sharedService.catalogNavigateHelper("admin", "catalog/layout/login");
                }
            });
        } else if (message.text == "apply-speaker-config") {
            if(!this.sharedService.isMSIE()) {
            window.dispatchEvent(new Event("resize"));
            }
            this.speakerConfig = cloneDeep(this.sharedService.speakerLayoutConfig);
            // For checking unsaved data
            this.sharedService.changedData = this.speakerConfig;

            this.drawerService.hideDrawer();

            this.fontstyle = {};
            setTimeout(() => {
                this.fontstyle = {
                    color: this.speakerConfig.labelConfig.fontColor,
                    "font-style": this.speakerConfig.labelConfig.fontStyle,
                    "text-decoration": this.speakerConfig.labelConfig.fontStyle,
                    "font-weight": this.speakerConfig.labelConfig.fontStyle,
                    "font-size": this.speakerConfig.labelConfig.fontSize + "px",
                    "padding-right": "5px"
                };
            }, 0);
            this.setBasedOnImageNameHelper("body");
            this.bodyLayout = this.getFormattedDDFData("body");
        }
    }

    openConfigDrawer(item, $event, expansionStyle) {
        $event.stopPropagation();
        let url = "";
        this.sharedService.speakerLayoutConfig = cloneDeep(this.speakerConfig);
        this.sharedService.expansionStyle = expansionStyle;
        if (item == "template") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Choose a different Template",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/template-config";
        } else if (item == "img") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Dynamic Image",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/image-config";
        } else if (item == "region") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Region",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/region-config";
        } else if (item == "html") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Text",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/html-config";
        } else if (item == "label") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Label",
                navLinks: null,
                saveMessage: "apply-speaker-config"
            };
            url = "config-drawer/speaker/label-config";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }

    toggleHTMLEnable(e) {
        this.speakerConfig.catalogConfig.enableSpeakerPopup = !this.speakerConfig.catalogConfig.enableSpeakerPopup;
    }
}
